import { i18n } from "../../i18n/i18n";

import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import subscriberService from '../../services/subscriber.service'
import adminRoutes from '../../routes/adminRoutes'
import subscriberApi, { SubscriberData } from '../../apis/subscriber.api'
import { ActionName } from '../../components/Actions'
import Button from '../../components/Button'
import ContentLayout from '../../components/ContentLayout'
import ContentMain from '../../components/ContentMain'
import HeadingRow from '../../components/HeadingRow'
import TableHorizontal, {
  TableHorizontalData,
  TableHorizontalHeader
} from '../../components/TableHorizontal'
import Card from '../../components/Card'

interface SubscribersProps extends RouteComponentProps {}

interface SubscribersState {
  subscribers: TableHorizontalData<SubscriberData>[]
}

class Subscribers extends Component<SubscribersProps, SubscribersState> {
  tableHeaders: TableHorizontalHeader[] = [
    { heading: i18n("Name"), path: 'name' },
    { heading: i18n("Logo"), path: 'logo', image: true },
    { heading: i18n("Sites"), path: 'sitesCount' },
    { heading: i18n("Users"), path: 'usersCount' },
    { heading: i18n("Created at"), path: 'createdAt', date: true },
    { heading: i18n("Updated at"), path: 'updatedAt', date: true },
    { heading: i18n("Actions") }
  ]

  constructor (props: SubscribersProps) {
    super(props)
    this.state = {
      subscribers: []
    }
    this.handleCreateClick = this.handleCreateClick.bind(this)
    this.handleActionClick = this.handleActionClick.bind(this)
  }

  handleActionClick (id: number, action: ActionName) {
    if (action === 'edit') {
      const pathname = adminRoutes.subscriberEdit
      const state = { id }
      this.props.history.push({ pathname, state })
    } else if (action === 'resume') {
      subscriberApi.block(id, subscriber => {
        if (!subscriber) return
        const subscribers = subscriberService.block(this.state.subscribers, id)
        this.setState({ subscribers })
      })
    } else if (action === 'start') {
      subscriberApi.unblock(id, subscriber => {
        if (!subscriber) return
        const subscribers = subscriberService.unblock(this.state.subscribers, id)
        this.setState({ subscribers })
      })
    }
  }

  handleCreateClick () {
    this.props.history.push(adminRoutes.subscriberCreate)
  }

  listSubscribers () {
    subscriberApi.list(subscribers => {
      if (!subscribers) return
      const subscribersData = subscriberService.tableHorizontalData(subscribers)
      this.setState({ subscribers: subscribersData })
    })
  }

  componentDidMount () {
    this.listSubscribers()
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="full">
          <Card>
            <HeadingRow heading={i18n("Subscribers")}>
              <Button
                text={i18n("Create")}
                onClick={this.handleCreateClick} />
            </HeadingRow>
            <TableHorizontal
              headers={this.tableHeaders}
              data={this.state.subscribers}
              onActionClick={this.handleActionClick} />
          </Card>
        </ContentMain>
      </ContentLayout>
    )
  }
}

export default withRouter(Subscribers)
